import { Navigate, Route, Routes } from 'react-router-dom';
import { useSesion } from './lib/sesion.js';
import { Marco } from './layout/Marco.js';
import { LoginPage } from './features/login/LoginPage.js';
import { ExploradorPage } from './features/explorador/ExploradorPage.js';
import { PapeleraPage } from './features/papelera/PapeleraPage.js';
import { UsuariosPage } from './features/admin/UsuariosPage.js';
import { GruposPage } from './features/admin/GruposPage.js';
import { BitacoraPage } from './features/admin/BitacoraPage.js';
import { CuotasPage } from './features/cuotas/CuotasPage.js';
import { PaginaCompartida } from './features/compartido/PaginaCompartida.js';

export function App() {
  return (
    <Routes>
      {/* Los enlaces compartidos se abren sin sesión: esta ruta va por fuera
          del marco de la aplicación y no pasa por el login. */}
      <Route path="/p/:token" element={<PaginaCompartida />} />
      <Route path="*" element={<Privado />} />
    </Routes>
  );
}

function Privado() {
  const { usuario, cargando, esAdmin } = useSesion();
  const esSuperAdmin = usuario?.rol === 'SUPER_ADMIN';

  if (cargando) return <div className="cargando">Cargando…</div>;
  if (!usuario) return <LoginPage />;

  return (
    <Marco>
      <Routes>
        <Route path="/" element={<Navigate to="/archivos" replace />} />
        <Route path="/archivos" element={<ExploradorPage />} />
        <Route path="/archivos/:carpetaId" element={<ExploradorPage />} />
        <Route path="/papelera" element={<PapeleraPage />} />
        {esAdmin && <Route path="/usuarios" element={<UsuariosPage />} />}
        {esAdmin && <Route path="/grupos" element={<GruposPage />} />}
        {esAdmin && <Route path="/bitacora" element={<BitacoraPage />} />}
        {esSuperAdmin && <Route path="/cuotas" element={<CuotasPage />} />}
        <Route path="*" element={<Navigate to="/archivos" replace />} />
      </Routes>
    </Marco>
  );
}
